<div class="editor">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <div class="config-name mb-4">
        <span nz-icon nzType="info-circle" nzTheme="outline"></span>
        <small style="line-height: normal;">{{'su_dung_cac_the' | translate}} <b>Heading 1, Heading 2, Heading 3, Heading 4, Heading 5, Heading 6</b> {{'khi_chinh_sua_noi_dung_tin_tuc_trong_admin_de_muc_luc_tu_dong_cap_nhat_khi_preview' | translate}}.</small>
      </div>

      <div class="mb-4 mt-2">
        <div class="mb-2" style="line-height: normal">{{'cap_toi_da_se_hien_thi' | translate}}</div>
        <nz-select [(ngModel)]="config['max_level_display']" (ngModelChange)="updateConfig()">
          <ng-container *ngFor="let level of [1, 2, 3, 4, 5, 6]">
            <nz-option [nzValue]="level" [nzLabel]="('cap' | translate) + ' ' + level"></nz-option>
          </ng-container>
        </nz-select>
      </div>
      
      <div class="mb-4 mt-2 highlight" nz-tooltip
      nzTooltipTitle="{{'chon_cap_ban_muon_chinh_sua_cac_thiet_lap_phia_duoi_se_ap_dung_cho_cap_nay' | translate}}">
        <div class="mb-2 highlight__title">
          {{'cap_can_cau_hinh' | translate}} 
          <span nz-icon nzType="question-circle" nzTheme="outline"></span>
        </div>
        <nz-select [(ngModel)]="selectedLevel">
          <ng-container *ngFor="let level of [1, 2, 3, 4, 5, 6]">
            <nz-option *ngIf="config['max_level_display'] >= level" [nzValue]="level" [nzLabel]="('cap' | translate) + ' ' + level"></nz-option>
          </ng-container>
        </nz-select>
      </div>
      
      <app-text-format-config 
      [objectChoosing]="objectChoosing" 
      [staticdata]="staticdata"
      [device]="device" 
      [class]="class"
      [config]="config" 
       
      [textContentClass]="class['table-of-content__link-' + this.selectedLevel]" 
      [textWrapperClass]="class['table-of-content__link-' + this.selectedLevel]">
    </app-text-format-config>
    </div>
  </ng-container>
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <!-- Dropdown menu -->
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- HIỂN THỊ -->
      <li nz-submenu [nzTitle]="'hien_thi' | translate" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="button-size">
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing"></app-hide-show-config>
        </div>
      </li>

      <div class="config-name mb-4">
        <span nz-icon nzType="info-circle" nzTheme="outline"></span>
        <small style="line-height: normal;">{{'su_dung_cac_the' | translate}} <b>Heading 1, Heading 2, Heading 3, Heading 4, Heading 5, Heading 6</b> {{'khi_chinh_sua_noi_dung_tin_tuc_trong_admin_de_muc_luc_tu_dong_cap_nhat_khi_preview' | translate}}.</small>
      </div>

      <div class="mb-4 mt-2">
        <div class="mb-2" style="line-height: normal">{{'cap_toi_da_se_hien_thi' | translate}}</div>
        <nz-select [(ngModel)]="config['max_level_display']" (ngModelChange)="updateConfig()">
          <ng-container *ngFor="let level of [1, 2, 3, 4, 5, 6]">
            <nz-option [nzValue]="level" [nzLabel]="('cap' | translate) + ' ' + level"></nz-option>
          </ng-container>
        </nz-select>
      </div>
      
      <div class="mb-4 mt-2 highlight" nz-tooltip
      nzTooltipTitle="{{'chon_cap_ban_muon_chinh_sua_cac_thiet_lap_phia_duoi_se_ap_dung_cho_cap_nay' | translate}}">
        <div class="mb-2 highlight__title">
          {{'cap_can_cau_hinh' | translate}} 
          <span nz-icon nzType="question-circle" nzTheme="outline"></span>
        </div>
        <nz-select [(ngModel)]="selectedLevel">
          <ng-container *ngFor="let level of [1, 2, 3, 4, 5, 6]">
            <nz-option *ngIf="config['max_level_display'] >= level" [nzValue]="level" [nzLabel]="('cap' | translate) + ' ' + level"></nz-option>
          </ng-container>
        </nz-select>
      </div>

      <!-- Khoảng cách -->
      <li nz-submenu [nzTitle]="'khoang_cach' | translate" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <div class="px-2">
          <ng-container *ngFor="let config of [ { type: 'top' }, { type: 'bottom' }, { type: 'left' }, { type: 'right' } ]">
            <div class="config-name">
              <p>{{ 'khoang_cach_' + getTranslatedLabel(config.type) | translate }}</p>
              <nz-input-number [nzMin]="0" [nzMax]="100" [nzStep]="1"
                [ngModel]="class['table-of-content__list-item-' + this.selectedLevel]['margin-' + config.type] | vhnumber" 
                (ngModelChange)="class['table-of-content__list-item-' + this.selectedLevel]['margin-' + config.type] = $event + 'px'" 
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="100" [nzStep]="1"
              [ngModel]="class['table-of-content__list-item-' + this.selectedLevel]['margin-' + config.type] | vhnumber" 
              (ngModelChange)="class['table-of-content__list-item-' + this.selectedLevel]['margin-' + config.type] = $event + 'px'" 
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </ng-container>
        </div>
      </li>

           <!-- Canh lề -->
     <li nz-submenu nzTitle="{{'canh_le' | translate}}" [(nzOpen)]="openMap.menu7"
     (nzOpenChange)="openHandler('menu7')">
        <app-padding-config
          [objectChoosing]="objectChoosing"
          [device]="device"
          [class]="class"
          [classPadding]="class['table-of-content']"
          [paddingConfigs]="[
            { type: 'top' },
            { type: 'bottom' },
            { type: 'left' },
            { type: 'right' }
          ]">
        </app-padding-config>
     </li>

      <!-- CHỮ VÀ ĐỊNH DẠNG -->
      <li nz-submenu [nzTitle]="'chu_va_dinh_dang' | translate" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">   
        <app-text-format-config 
          [objectChoosing]="objectChoosing" 
          [staticdata]="staticdata"
          [device]="device" 
          [class]="class"
          [config]="config" 
           
          [textContentClass]="class['table-of-content__link-' + this.selectedLevel]" 
          [textWrapperClass]="class['table-of-content__link-' + this.selectedLevel]">
        </app-text-format-config>

        <div class="mt-4">
          <!-- Khoảng cách chữ -->
          <app-letter-spacing-config
            [objectChoosing]="objectChoosing"
            [device]="device"
            [class]="class"
            [classLetterSpacing]="class['table-of-content__link-' + this.selectedLevel]"
            (updateClass)="updateClass()">
          </app-letter-spacing-config>
          <!-- Khoảng cách dòng -->
          <app-line-height-config
              [objectChoosing]="objectChoosing"
              [device]="device"
              [class]="class"
              [classLineHeight]="class['table-of-content__link-' + this.selectedLevel]"
              (updateClass)="updateClass()">
          </app-line-height-config>
        </div>
      </li>

      <!-- KIỂU VIỀN CHUNG -->
      <li nz-submenu [nzTitle]="'kieu_vien_chung' | translate" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-borders-config  [elementChoosing]="objectChoosing"
          [id_object]="objectChoosing._id"
          [device]="device" 
          [class]="class" 
          [borderClass]="class['table-of-content']">
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="my-4 cursor-pointer" style="float: right" role="button">
          <p class="m-0" (click)="openViewAll(style_fields[0])">
            {{ 'mo_rong' | translate }} &#8594;
          </p>
        </div>
      </li>

      <!-- KIỂU VIỀN CẤP ĐƯỢC CHỌN -->
      <li nz-submenu [nzTitle]="'kieu_vien_cap_duoc_chon' | translate" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <app-borders-config  [elementChoosing]="objectChoosing"
          [id_object]="objectChoosing._id"
          [device]="device" 
          [class]="class" 
          [borderClass]="class['table-of-content__list-item-' + this.selectedLevel]">
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="my-4 cursor-pointer" style="float: right" role="button">
          <p class="m-0" (click)="openViewAll(style_fields[1])">
            {{ 'mo_rong' | translate }} &#8594;
          </p>
        </div>
      </li>

      <!-- MÀU NỀN -->
      <li nz-submenu [nzTitle]="'mau_nen' | translate" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
        <!-- Màu nền chung -->
        <div class="config-name">
          <p>{{'mau_nen_chung' | translate}}</p>
          <div>
            <input class="input-color" type="button" [cpOKButton]="true" 
              [style.background]="class['table-of-content']['background-color']"
              [(colorPicker)]="class['table-of-content']['background-color']"
              (colorPickerClose)="updateClass()" />
          </div>
        </div>

        <div class="config-name">
          <p>{{'mau_nen_cap_duoc_chon' | translate}} ({{'cap' | translate}} {{selectedLevel}})</p>
          <div>
            <input class="input-color" type="button" [cpOKButton]="true" 
              [style.background]="class['table-of-content__list-item-' + selectedLevel]['background-color']"
              [(colorPicker)]="class['table-of-content__list-item-' + selectedLevel]['background-color']"
              (colorPickerClose)="updateClass()" />
          </div>
        </div>
      </li>

    </ul>
  </ng-container>


  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Bo tròn viền 'table-of-content' -->
    <div class="view_more-border" *ngIf="currentViewAll.index === 1">
      <app-borders-radius-config 
        [borderRadiusClass]="class['table-of-content']"
        [device]="device" 
        [class]="class" 
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
    <!-- Bo tròn viền 'table-of-content__list-item-' + selectedLevel -->
    <div class="view_more-border" *ngIf="currentViewAll.index === 2">
      <app-borders-radius-config 
        [borderRadiusClass]="class['table-of-content__list-item-' + selectedLevel]"
        [device]="device" 
        [class]="class" 
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>

</div>
